<div class="dialog-container">
    <div class="dialog-header">
        <div class="icon-container">
            <mat-icon [class]="getIconClass()">
                <ng-container [ngSwitch]="data.type">
                    <span *ngSwitchCase="'warning'">⚠️</span>
                    <span *ngSwitchCase="'error'">❌</span>
                    <span *ngSwitchCase="'success'">✅</span>
                    <span *ngSwitchDefault>ℹ️</span>
                </ng-container>
            </mat-icon>
        </div>
        <h2 mat-dialog-title class="dialog-title">{{ data.title }}</h2>
    </div>

    <div mat-dialog-content class="dialog-content">
        <p class="dialog-message">{{ data.message }}</p>
    </div>

    <div mat-dialog-actions class="dialog-actions">
        <button
            *ngIf="data.showCancel !== false"
            mat-button
            (click)="onCancel()"
            class="cancel-button"
            tabindex="-1"
        >
            {{ data.cancelText || "Cancelar" }}
        </button>
        <button
            mat-raised-button
            (click)="onConfirm()"
            [class]="getConfirmButtonClass()"
            tabindex="0"
        >
            {{ data.confirmText || "Confirmar" }}
        </button>
    </div>
</div>
